var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      attrs: { title: "Share template", visible: _vm.visible },
      on: { close: _vm.close },
    },
    [
      _c("div", [
        _c("p", { staticClass: "c-paragraph" }, [
          _vm._v(
            "\n            Copy this link and share this template with your friends\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal__input" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.absoluteUrl,
                expression: "absoluteUrl",
              },
            ],
            staticClass: "c-input u-margin-vertical-xs copy-js",
            attrs: { type: "text", readonly: "" },
            domProps: { value: _vm.absoluteUrl },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.absoluteUrl = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "clipboard",
                  rawName: "v-clipboard:success",
                  value: _vm.copy,
                  expression: "copy",
                  arg: "success",
                },
                {
                  name: "clipboard",
                  rawName: "v-clipboard:copy",
                  value: _vm.absoluteUrl,
                  expression: "absoluteUrl",
                  arg: "copy",
                },
              ],
              staticClass: "c-button c-button--secondary",
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.isCopied ? "Copied!" : "Copy") +
                  "\n            "
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }